export const HIDE_POPUP = 'HIDE_POPUP'

export const hidePopup = () => (dispatch: any) => {
  dispatch({
    type: HIDE_POPUP,
  })
}
